'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _get = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;
  var desc = Object.getOwnPropertyDescriptor(object, property);

  if (desc === undefined) {
    var parent = Object.getPrototypeOf(object);

    if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;

    if (getter === undefined) {
      return undefined;
    }

    return getter.call(receiver);
  }
};

var _class, _temp, _extends2, _class2, _temp2, _class3, _temp3;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _context7 = require('@prisma-cms/context');

var _context8 = _interopRequireDefault(_context7);

var _reactApollo = require('react-apollo');

var _graphqlTag = require('graphql-tag');

var _graphqlTag2 = _interopRequireDefault(_graphqlTag);

var _TextField = require('material-ui/TextField');

var _TextField2 = _interopRequireDefault(_TextField);

var _Button = require('material-ui/Button');

var _Button2 = _interopRequireDefault(_Button);

var _Typography = require('material-ui/Typography');

var _Typography2 = _interopRequireDefault(_Typography);

var _component = require('@prisma-cms/component');

var _component2 = _interopRequireDefault(_component);

var _ = require('../');

var _2 = _interopRequireDefault(_);

var _Dialog = require('material-ui/Dialog');

var _LinearProgress = require('material-ui/Progress/LinearProgress');

var _LinearProgress2 = _interopRequireDefault(_LinearProgress);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var AuthUsers = (_temp = _class = function (_AuthForm) {
  _inherits(AuthUsers, _AuthForm);

  function AuthUsers() {
    _classCallCheck(this, AuthUsers);

    return _possibleConstructorReturn(this, (AuthUsers.__proto__ || Object.getPrototypeOf(AuthUsers)).apply(this, arguments));
  }

  _createClass(AuthUsers, [{
    key: 'renderSearchForm',
    value: function renderSearchForm() {
      var _this2 = this;

      var getFilters = this.props.getFilters;
      var name = "search";

      var _ref = getFilters() || {},
          search = _ref[name];

      return this.renderField(_react2.default.createElement(_TextField2.default, {
        label: this.lexicon("Login"),
        helperText: this.lexicon("Login, email, phone or user ID"),
        fullWidth: true,
        name: name,
        value: search || "",
        onChange: function onChange(event) {
          var _event$target = event.target,
              value = _event$target.value,
              name = _event$target.name;

          _this2.setFilters(_defineProperty({}, name, value ? value : undefined));
        }
      }));
    }
  }, {
    key: 'setFilters',
    value: function setFilters(filters) {
      var setFilters = this.props.setFilters;
      return setFilters(filters);
    }
  }, {
    key: 'signin',
    value: function () {
      var _ref2 = _asyncToGenerator(
      /*#__PURE__*/
      _regenerator2.default.mark(function _callee(options) {
        var _this3 = this;

        var _ref3, _ref3$signin, signin;

        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _ref3 = this.context.query || {}, _ref3$signin = _ref3.signin, signin = _ref3$signin === undefined ? '\n        mutation signin(\n          $where:UserWhereUniqueInput!\n          $data:SigninDataInput!\n        ){\n          response: signin(\n            where:$where\n            data:$data\n          ){\n            success\n            message\n            errors{\n              key\n              message\n            }\n            token\n            data{\n              ...user\n            }\n          }\n        }\n        \n        fragment user on User {\n          id\n          username\n          email\n          phone\n          showEmail\n          showPhone\n          sudo\n          hasEmail\n          hasPhone\n        }\n      ' : _ref3$signin; // return;

                _context.next = 3;
                return this.mutate(_extends({
                  mutation: (0, _graphqlTag2.default)(signin)
                }, options)).then(function (r) {
                  _this3.onAuth(r);

                  return r;
                }).catch(console.error);

              case 3:
                return _context.abrupt('return', _context.sent);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function signin(_x) {
        return _ref2.apply(this, arguments);
      }

      return signin;
    }()
  }, {
    key: 'resetPassword',
    value: function () {
      var _ref4 = _asyncToGenerator(
      /*#__PURE__*/
      _regenerator2.default.mark(function _callee2(options) {
        var _this4 = this;

        var _ref5, _ref5$resetPasswordPr, resetPasswordProcessor, resetPasswordInRequest, result;

        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _ref5 = this.context.query || {}, _ref5$resetPasswordPr = _ref5.resetPasswordProcessor, resetPasswordProcessor = _ref5$resetPasswordPr === undefined ? '\n        mutation resetPasswordProcessor(\n          $where: UserWhereUniqueInput!\n          $data:ResetPasswordInput!\n        ){\n          response: resetPasswordProcessor(\n            where: $where\n            data:$data\n          ){\n            success\n            message\n            errors{\n              key\n              message\n            }\n            token\n            data{\n              ...user\n            }\n          }\n        }\n        \n        \n        fragment user on User {\n          id\n          username\n          email\n          phone\n          showEmail\n          showPhone\n          sudo\n          hasEmail\n          hasPhone\n        }\n      ' : _ref5$resetPasswordPr;
                resetPasswordInRequest = this.state.resetPasswordInRequest;

                if (!resetPasswordInRequest) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt('return');

              case 4:
                this.setState({
                  resetPasswordInRequest: true
                }); // return;

                _context2.next = 7;
                return this.mutate(_extends({
                  mutation: (0, _graphqlTag2.default)(resetPasswordProcessor)
                }, options)).then(function (r) {
                  _this4.onAuth(r);

                  return r;
                }).catch(console.error);

              case 7:
                result = _context2.sent;
                this.setState({
                  resetPasswordInRequest: false
                });
                return _context2.abrupt('return', result);

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function resetPassword(_x2) {
        return _ref4.apply(this, arguments);
      }

      return resetPassword;
    }()
  }, {
    key: 'cleanFilters',
    value: function cleanFilters() {
      var cleanFilters = this.props.cleanFilters;
      return cleanFilters();
    }
  }, {
    key: 'cleanForm',
    value: function cleanForm() {
      this.cleanFilters();
      this.setState({
        resetPasswordId: null,
        resetPasswordCode: null
      });

      _get(AuthUsers.prototype.__proto__ || Object.getPrototypeOf(AuthUsers.prototype), 'cleanForm', this).call(this);
    }
  }, {
    key: 'onRequestClose',
    value: function onRequestClose(event) {
      this.cleanForm();
      return _get(AuthUsers.prototype.__proto__ || Object.getPrototypeOf(AuthUsers.prototype), 'onRequestClose', this).call(this);
    }
  }, {
    key: 'renderForm',
    value: function renderForm() {
      var _this5 = this;

      var _context3 = this.context,
          Grid = _context3.Grid,
          UserLink = _context3.UserLink,
          Pagination = _context3.Pagination,
          Avatar = _context3.Avatar,
          uri = _context3.uri;
      var _props = this.props,
          data = _props.data,
          password = _props.password,
          onPasswordChange = _props.onPasswordChange,
          cleanFilters = _props.cleanFilters,
          useMetamask = _props.useMetamask;
      var _state = this.state,
          resetPasswordId = _state.resetPasswordId,
          resetPasswordCode = _state.resetPasswordCode,
          resetPasswordInRequest = _state.resetPasswordInRequest,
          inRequest = _state.inRequest;
      var users = [];
      var count = 0;
      /**
       * Если найдено более одного пользователя, требуем уточнения, 
       * какой именно пользователь нужен
       */

      var searchForm = void 0;
      var usersList = void 0; // let user = this.getUser();

      var user = void 0;

      if (!resetPasswordId) {
        searchForm = this.renderSearchForm();
      }

      var _uri$query = uri.query(true),
          authPage = _uri$query.authPage;

      if (data) {
        var objectsConnection = data.objectsConnection,
            first = data.variables.first;
        users = objectsConnection ? objectsConnection.edges.map(function (n) {
          return n.node;
        }) : [];
        count = objectsConnection ? objectsConnection.aggregate.count : 0;

        if (users.length) {
          if (count === 1) {
            user = users[0];
          } else {
            usersList = _react2.default.createElement(Grid, {
              container: true,
              spacing: 8
            }, _react2.default.createElement(Grid, {
              item: true,
              xs: 12
            }, _react2.default.createElement(_Typography2.default, {
              variant: 'caption'
            }, this.lexicon("Choose user from list"))), users.map(function (n) {
              var userId = n.id,
                  username = n.username,
                  email = n.email;
              return _react2.default.createElement(Grid, {
                key: userId,
                item: true,
                xs: 12
              }, _react2.default.createElement(UserLink, {
                user: n,
                onClick: function onClick(event) {
                  event.preventDefault();
                  event.stopPropagation();

                  _this5.setFilters({
                    search: userId
                  });
                }
              }));
            }), _react2.default.createElement(Grid, {
              item: true,
              xs: 12
            }, _react2.default.createElement(Pagination, {
              authPage: authPage,
              pageVariable: 'authPage',
              limit: first,
              total: count
            })));
          }
        }
      }

      var userAvatar = void 0;

      if (user) {
        var _user = user,
            username = _user.username,
            fullname = _user.fullname,
            _userId = _user.id;
        userAvatar = _react2.default.createElement('div', {
          style: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center"
          }
        }, _react2.default.createElement(Avatar, {
          size: 'big',
          user: user
        }), _react2.default.createElement(_Typography2.default, {
          variant: 'subheading'
        }, username || _userId, ' ', fullname ? '(' + fullname + ')' : null), _react2.default.createElement(Grid, {
          container: true,
          spacing: 8
        }, _react2.default.createElement(Grid, {
          item: true,
          xs: 12
        })));
      }

      var _onSubmit = void 0;

      var actions = [];

      if (!user) {
        if (useMetamask) {
          actions.push(_react2.default.createElement(_Button2.default, {
            key: 'metamask' // color="primary"
            ,
            onClick: function onClick(event) {
              _this5.switchForm("metamask");
            },
            size: 'small'
          }, this.lexicon("Metamask")));
        }

        actions.push(_react2.default.createElement(_Button2.default, {
          key: 'registration' // color="primary"
          ,
          onClick: function onClick(event) {
            _this5.switchForm("signup");
          },
          size: 'small'
        }, this.lexicon("Signup")));
      }

      actions.push(_react2.default.createElement(_Button2.default, {
        key: 'cancel' // color="primary"
        ,
        onClick: function onClick(event) {
          _this5.closeForm();
        },
        size: 'small'
      }, this.lexicon("Cancel"))); // const user = this.getUser();

      var mainAction = void 0;

      if (user) {
        if (resetPasswordId) {
          mainAction = this.renderField(_react2.default.createElement(_TextField2.default, {
            fullWidth: true,
            name: 'code',
            value: resetPasswordCode || "",
            label: this.lexicon("Code"),
            helperText: this.lexicon("Type confirm code") // type="password"
            ,
            onChange: function onChange(event) {
              var value = event.target.value;

              _this5.setState({
                resetPasswordCode: value
              });
            }
          }));

          _onSubmit = function onSubmit() {
            _this5.resetPassword({
              variables: {
                where: {
                  id: _userId2
                },
                data: {
                  code: resetPasswordCode || ""
                }
              }
            });
          };

          actions.push(_react2.default.createElement(_Button2.default, {
            key: 'submit',
            color: 'primary',
            type: 'submit',
            size: 'small',
            disabled: resetPasswordInRequest ? true : false
          }, "\u0421\u0431\u0440\u043E\u0441\u0438\u0442\u044C \u043F\u0430\u0440\u043E\u043B\u044C"));
        } else {
          mainAction = this.renderField(_react2.default.createElement(_TextField2.default, {
            fullWidth: true,
            name: 'password',
            value: password || "",
            label: this.lexicon("Password"),
            helperText: this.lexicon("Type password"),
            type: 'password',
            onChange: function onChange(event) {
              var value = event.target.value;
              onPasswordChange(value);
            }
          }));

          _onSubmit = function onSubmit() {
            _this5.signin({
              variables: {
                where: {
                  id: _userId2
                },
                data: {
                  password: password
                }
              }
            });
          };

          actions.push(_react2.default.createElement(_Button2.default // color="primary"
          , {
            key: 'newPassword',
            size: 'small',
            onClick: function () {
              var _ref6 = _asyncToGenerator(
              /*#__PURE__*/
              _regenerator2.default.mark(function _callee3(event) {
                var _ref7, _ref7$createResetPass, createResetPasswordProcessor;

                return _regenerator2.default.wrap(function _callee3$(_context4) {
                  while (1) {
                    switch (_context4.prev = _context4.next) {
                      case 0:
                        _ref7 = _this5.context.query || {}, _ref7$createResetPass = _ref7.createResetPasswordProcessor, createResetPasswordProcessor = _ref7$createResetPass === undefined ? '\n                mutation createResetPasswordProcessor(\n                  $data:ResetPasswordCreateInput!\n                ){\n                  response: createResetPasswordProcessor(\n                    data:$data\n                  ){\n                    success\n                    message\n                    errors{\n                      key\n                      message\n                    }\n                    data{\n                      id\n                      code\n                      validTill\n                    }\n                  }\n                }\n              ' : _ref7$createResetPass;

                        _this5.mutate({
                          mutation: (0, _graphqlTag2.default)(createResetPasswordProcessor),
                          variables: {
                            data: {
                              User: {
                                connect: {
                                  id: _userId2
                                }
                              }
                            }
                          }
                        }).then(function (r) {
                          var _ref8 = r.data.response && r.data.response.data || {},
                              resetPasswordId = _ref8.id;

                          if (resetPasswordId) {
                            _this5.setState({
                              resetPasswordId: resetPasswordId
                            });
                          }

                          return r;
                        });

                      case 2:
                      case 'end':
                        return _context4.stop();
                    }
                  }
                }, _callee3, _this5);
              }));

              return function (_x3) {
                return _ref6.apply(this, arguments);
              };
            }()
          }, this.lexicon("Reset password")));
          actions.push(_react2.default.createElement(_Button2.default, {
            key: 'submit',
            color: 'primary',
            type: 'submit',
            size: 'small'
          }, this.lexicon("Signin")));
        }

        var _user2 = user,
            _userId2 = _user2.id;
      }

      var title = this.lexicon("Authorization");
      return _react2.default.createElement('form', {
        style: {
          width: "100%"
        },
        onSubmit: function onSubmit(event) {
          event.preventDefault();

          if (_onSubmit) {
            _onSubmit();
          }
        }
      }, inRequest ? _react2.default.createElement(_LinearProgress2.default, null) : null, _react2.default.createElement(_Dialog.DialogTitle, null, title), _react2.default.createElement(_Dialog.DialogContent // classes={{
      //   root: classes.DialogContentRoot,
      // }}
      , null, _react2.default.createElement(Grid, {
        container: true,
        spacing: 8
      }, _react2.default.createElement(Grid, {
        item: true,
        xs: 12
      }, userAvatar), _react2.default.createElement(Grid, {
        item: true,
        xs: 12
      }, usersList), _react2.default.createElement(Grid, {
        item: true,
        xs: 12
      }, searchForm), _react2.default.createElement(Grid, {
        item: true,
        xs: 12
      }), _react2.default.createElement(Grid, {
        item: true,
        xs: 12
      }, mainAction))), _react2.default.createElement(_Dialog.DialogActions, null, actions)); // return (
      //   <div>
      //     {usersList}
      //     {searchForm}
      //   </div>
      // );
    }
  }]);

  return AuthUsers;
}(_2.default), _class.propTypes = _extends({}, _2.default.propTypes, (_extends2 = {
  data: _propTypes2.default.object,
  setFilters: _propTypes2.default.func.isRequired,
  getFilters: _propTypes2.default.func.isRequired
}, _defineProperty(_extends2, 'getFilters', _propTypes2.default.func.isRequired), _defineProperty(_extends2, 'onPasswordChange', _propTypes2.default.func.isRequired), _defineProperty(_extends2, 'password', _propTypes2.default.string.isRequired), _defineProperty(_extends2, 'loginComplete', _propTypes2.default.func.isRequired), _extends2)), _temp);
var AuthUsersConnector = (_temp2 = _class2 = function (_Component) {
  _inherits(AuthUsersConnector, _Component);

  function AuthUsersConnector() {
    _classCallCheck(this, AuthUsersConnector);

    return _possibleConstructorReturn(this, (AuthUsersConnector.__proto__ || Object.getPrototypeOf(AuthUsersConnector)).apply(this, arguments));
  }

  _createClass(AuthUsersConnector, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _ref9 = this.context.query || {},
          _ref9$usersConnection = _ref9.usersConnection,
          usersConnection = _ref9$usersConnection === undefined ? '\n        query usersConnection (\n          $where:UserWhereInput\n          $first:Int = 10\n          $skip:Int\n          $orderBy:UserOrderByInput\n        ){\n          objectsConnection: usersConnection (\n            where: $where\n            first:$first\n            skip:$skip\n            orderBy: $orderBy\n          ){\n            aggregate{\n              count\n            }\n            edges{\n              node{\n                ...user\n              }\n            }\n          }\n        }\n        \n        fragment user on User {\n          id\n          username\n          email\n          phone\n          showEmail\n          showPhone\n          sudo\n          hasEmail\n          hasPhone\n        }\n      ' : _ref9$usersConnection;

      var View = this.props.View;
      this.Renderer = (0, _reactApollo.compose)((0, _reactApollo.graphql)((0, _graphqlTag2.default)(usersConnection), {
        skip: function skip(props) {
          return !props.where ? true : false;
        },
        options: function options(props) {
          var _ref10 = props || {},
              where = _ref10.where,
              other = _objectWithoutProperties(_ref10, ['where']);

          return {
            variables: _extends({
              where: _extends({
                showHidden: true
              }, where)
            }, other)
          };
        }
      }))(View);
      _get(AuthUsersConnector.prototype.__proto__ || Object.getPrototypeOf(AuthUsersConnector.prototype), 'componentWillMount', this) && _get(AuthUsersConnector.prototype.__proto__ || Object.getPrototypeOf(AuthUsersConnector.prototype), 'componentWillMount', this).call(this);
    }
  }, {
    key: 'render',
    value: function render() {
      var Renderer = this.Renderer;

      var _props2 = this.props,
          View = _props2.View,
          other = _objectWithoutProperties(_props2, ['View']);

      return _react2.default.createElement(Renderer, other);
    }
  }]);

  return AuthUsersConnector;
}(_react.Component), _class2.contextType = _context8.default, _class2.propTypes = {
  View: _propTypes2.default.func.isRequired
}, _class2.defaultProps = {
  View: AuthUsers
}, _temp2);
var AuthUsersForm = (_temp3 = _class3 = function (_PrismaCmsComponent) {
  _inherits(AuthUsersForm, _PrismaCmsComponent);

  function AuthUsersForm() {
    _classCallCheck(this, AuthUsersForm);

    return _possibleConstructorReturn(this, (AuthUsersForm.__proto__ || Object.getPrototypeOf(AuthUsersForm)).apply(this, arguments));
  }

  _createClass(AuthUsersForm, [{
    key: 'getFilters',
    value: function getFilters() {
      var uri = this.context.uri;

      var _uri$query2 = uri.query(true),
          page = _uri$query2.page,
          filters = _uri$query2.authFilters;

      if (filters) {
        try {
          filters = filters && JSON.parse(filters) || null;
        } catch (error) {
          console.error(console.error(error));
        }
      }

      return filters;
    }
  }, {
    key: 'setFilters',
    value: function setFilters(filters) {
      var _context5 = this.context,
          uri = _context5.uri,
          history = _context5.router.history;
      var newUri = uri.clone();
      var currentFilters = this.getFilters();
      filters = _extends({}, currentFilters, filters);

      try {
        filters = filters ? JSON.stringify(filters) : undefined;
      } catch (error) {
        console.error(error);
      }

      if (filters === "{}") {
        filters = undefined;
      }

      if (filters) {
        // if (newUri.hasQuery) {
        newUri = newUri.setQuery({
          authFilters: filters
        }); // }
        // else {
        //   newUri = newUri.addQuery({
        //     filters,
        //   });
        // }
      } else {
        newUri.removeQuery("authFilters");
      }

      newUri.removeQuery("authPage");
      var url = newUri.resource();
      history.push(url);
    }
  }, {
    key: 'cleanFilters',
    value: function cleanFilters() {
      var _context6 = this.context,
          uri = _context6.uri,
          history = _context6.router.history;
      var newUri = uri.clone();
      newUri.removeQuery("authPage");
      newUri.removeQuery("authFilters");
      var url = newUri.resource();
      history.push(url);
    }
  }, {
    key: 'prepareWhere',
    value: function prepareWhere() {
      return this.getFilters();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this8 = this;

      var uri = this.context.uri;

      var _props3 = this.props,
          first = _props3.first,
          other = _objectWithoutProperties(_props3, ['first']);

      var password = this.state.password;

      var _uri$query3 = uri.query(true),
          authPage = _uri$query3.authPage;

      var skip = void 0;

      if (authPage > 1 && first) {
        skip = (authPage - 1) * first;
      }

      return _react2.default.createElement(AuthUsersConnector, _extends({
        first: first,
        skip: skip,
        where: this.prepareWhere(),
        setFilters: function setFilters(filters) {
          return _this8.setFilters(filters);
        },
        getFilters: function getFilters() {
          return _this8.getFilters();
        },
        cleanFilters: function cleanFilters() {
          return _this8.cleanFilters();
        },
        password: password || "",
        onPasswordChange: function onPasswordChange(password) {
          _this8.setState({
            password: password
          });
        }
      }, other));
    }
  }]);

  return AuthUsersForm;
}(_component2.default), _class3.propTypes = _extends({}, _component2.default.propTypes, {
  first: _propTypes2.default.number.isRequired
}), _class3.defaultProps = _extends({}, _component2.default.defaultProps, {
  first: 3
}), _temp3);
exports.default = AuthUsersForm;
;
module.exports = exports['default'];